import { refreshToken } from "./tokenRefresh";

export const onResponseError = (client) => {
  return (error) => {
    console.error("Request Failed:", error.config);

    const responseStatus = error.response ? error.response.status : 0;
    const originalRequest = error.config;

    if (responseStatus === 401) {
      console.log("Unauthorized Access, sending refresh token");
      return refreshToken(client, originalRequest);
    } else if (responseStatus === 403) {
      console.log("Forbidden Access");
    } else if (responseStatus >= 400) {
      if (responseStatus !== 403) {
        console.log("Redirecting to ErrorPage");
      } else {
        console.error("Error Message:", error.message);
      }
    } else {
      console.error("Ocorreu um erro ao processar sua solicitação");
    }

    return Promise.reject(error);
  };
};
